/**
 * Bug Reports Kanban Configuration
 * 
 * Configuration for the Bug Reports kanban board using the global Kanban component.
 */

import { KanbanConfig } from '../types';
import { BugReport, BugStatus } from 'shared/types/bug-report';
import { bugPhaseColumns } from 'screens/bug-reports/bugReportPhaseConfig';

/**
 * Bug Reports Kanban Configuration
 * 
 * This config defines how the Bug Reports kanban should look and behave:
 * - Uses phase columns from bugReportPhaseConfig (single source of truth)
 * - Shows count per column
 * - Non-scrollable columns (full height)
 */
export const bugReportsKanbanConfig: KanbanConfig<BugReport, BugStatus> = {
  // Column definitions from existing bugReportPhaseConfig
  columns: bugPhaseColumns,

  // Get the status for a bug report
  getItemStatus: (bug: BugReport) => bug.status,

  // Show count badge per column
  showCount: true,

  // No add button for bug reports
  showAddButton: false,

  // Empty state configuration
  emptyState: {
    message: 'Geen bugs',
  },

  // Page scrolls instead of individual columns
  scrollableColumns: false,

  // Fixed column width to enable horizontal scrolling with 7 columns
  gridCols: 'grid-flow-col auto-cols-[280px]',
};

